module.exports = __webpack_public_path__ + "img/visiosign_cloud_logo_pos.1c4198e1.svg";